import { useEffect, useState } from 'react'
import {
  faAngular,
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p className='text-content'>
          Hey there, I'm Akshat, your friendly neighborhood code explorer, and a software developer on a mission to turn caffeine into code! 🚀
          </p>
          <p className='text-content3'>
          With a profound understanding of web development, I specialize in translating concepts into seamless, responsive, and user-friendly designs. I'm a fullstack developer who thrives on refining the user experience. I'm always eager to take on new challenges and raise the bar for web development standards.
          I'm also fascinated by the world of Artificial Intelligence and Machine Learning. It's like teaching computers to be the cool sidekicks we always wished for. Whether it's predicting trends or creating intelligent chatbots, I'm thrilled to be at the forefront of this technological marvel.
</p><p className='text-content2'> If you're as passionate about tech and innovation as I am, let's connect and embark on this incredible journey together. Ready for the future? Let's innovate, one line of code at a time!
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faAngular} color="#DD0031" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
